import React, { FC } from 'react';
import { RouteComponentProps } from 'react-router';

import { useHeader } from '../components/common/navigation/hooks/header-service';
import Download from '../components/common/download';

type FilePageProps = RouteComponentProps<
  {
    id: string;
  },
  { statusCode?: number },
  unknown
>;

const FilePage: FC<FilePageProps> = (props) => {
  useHeader('Файл #' + props.match.params.id, []);

  return (
    <>
      <Download id={props.match.params.id} />
    </>
  );
};

export default FilePage;
